/** Top npm packages common in AI-built app stacks (typosquat reference list). */
export const POPULAR_NPM_PACKAGES: readonly string[] = [
  'next',
  'react',
  'react-dom',
  'vue',
  '@vue/cli',
  'express',
  'lodash',
  'axios',
  'stripe',
  '@stripe/stripe-js',
  'supabase',
  '@supabase/supabase-js',
  '@prisma/client',
  'prisma',
  'typescript',
  'eslint',
  'prettier',
  'tailwindcss',
  'vite',
  'zod',
  'dotenv',
  'jsonwebtoken',
  'bcrypt',
  'mongoose',
  'pg',
  'redis',
  'ioredis',
  'winston',
  '@sentry/node',
  '@sentry/nextjs',
  'firebase',
  '@clerk/nextjs',
  'openai',
  '@anthropic-ai/sdk',
  'vercel',
  '@vercel/analytics',
];
